import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Link } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const NoTouchPurchaseSummaryModalDetailsInfo = styled(Flex)`
    padding: 8px;
    width: 100%;
    background-color: ${colorsPalettes.bluegrey[200]};
    border-radius: 4px;
    gap: 4px;
`;

export const Divider = styled.hr`
    margin: 0;
    width: 100%;
`;

export const StyledLink = styled(Link)<{ isSmallOneClickTest?: boolean }>`
    color: ${colorsPalettes.blue[400]};
    ${({ isSmallOneClickTest }) => setFontVariant(isSmallOneClickTest ? "dataTable2" : "caption")};
`;
export const SmallDetailsLoaderWrapper = styled(Stack)`
    margin-top: 20px;
    align-items: center;
    gap: 24px;
`;
